export const fileTypes = {
  csv: {
    mime: ['text/csv', 'application/vnd.ms-excel'],
  },
  pdf: {
    mime: ['application/pdf'],
  },
};

export const allowedFileTypes = (FileTypes) => {
  return FileTypes.reduce(
    (item, FileType) => item.concat(fileTypes[FileType].mime),
    [],
  );
};

export const requiredFileErrorMessage = (allowedFileExtension) =>
  `Please select a ${allowedFileExtension.join().toUpperCase()} file`;
